import { render, staticRenderFns } from "./APIKeys.vue?vue&type=template&id=45705834&scoped=true"
import script from "./APIKeys.vue?vue&type=script&lang=ts"
export * from "./APIKeys.vue?vue&type=script&lang=ts"
import style0 from "./APIKeys.vue?vue&type=style&index=0&id=45705834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45705834",
  null
  
)

export default component.exports